module.exports = __webpack_public_path__ + "static/media/day-75-measurements.49dcf6aa.svg";